<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-injection-cl"
  [title]="'P0003605.dashboard.injectionCL' | translate"
  [content]="
    buttonMode[this.actionStack!.getValue('icCModeFonctionnement')].icon!
  "
  [color]="
    buttonMode[this.actionStack!.getValue('icCModeFonctionnement')].color!
  "
  [status]="
    buttons[this.actionStack!.getValue('icSEtatPompe')].title! | translate
  "
  [statusMode]="buttons[this.actionStack!.getValue('icSEtatPompe')].status!"
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
